

































































































































import axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Home extends Vue {
  topPosts:object = []
  loading:boolean = true

  mounted () {
    axios.get('/api/news/latest').then(
      response => {
        this.topPosts = response.data
        this.loading = false
      }
    )
  }
}
